// First-Touch-Attribution für Anfrage-Formulare.
// Speichert UTM-Parameter, fbclid und Referrer beim ersten Besuch in localStorage
// (First-Party, rein technisch zur Übermittlung der Herkunft mit der eigenen Anfrage).

const KEY = "dh-attribution";
const REF_KEY = "dh-ref";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content"];

export function getAffiliateRef() {
  try {
    return localStorage.getItem(REF_KEY);
  } catch {
    return null;
  }
}

function captureRef(params) {
  const raw = params.get("ref");
  if (!raw) return;
  const code = raw.trim().toUpperCase().slice(0, 40);
  if (!code) return;
  try {
    localStorage.setItem(REF_KEY, code);
    if (!sessionStorage.getItem("dh-ref-tracked")) {
      sessionStorage.setItem("dh-ref-tracked", "1");
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/affiliate/click`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code, path: window.location.pathname }),
      }).catch(() => {});
    }
  } catch {
    /* Storage nicht verfügbar */
  }
}

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    captureRef(params);
    const current = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) current[k] = v.slice(0, 160);
    });
    const fbclid = params.get("fbclid");
    if (fbclid) current.fbclid = fbclid.slice(0, 200);

    const existing = read();
    // First-Touch: einmal erfasste Kampagnen-Daten nie überschreiben
    if (existing && (existing.utm_source || existing.fbclid)) return;

    const hasCampaignData = Object.keys(current).length > 0;
    if (!hasCampaignData && existing) return;

    const record = {
      ...current,
      referrer: (document.referrer || "").slice(0, 300) || null,
      landing_page: (window.location.pathname + window.location.search).slice(0, 300),
      captured_at: new Date().toISOString(),
    };
    localStorage.setItem(KEY, JSON.stringify(record));
  } catch {
    /* Storage nicht verfügbar – Anfrage funktioniert trotzdem */
  }
}

export function getAttribution() {
  const rec = read();
  const ref = getAffiliateRef();
  if (!ref) return rec;
  return { ...(rec || {}), ref };
}
